import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../../UserSearchScreenStyles';
import { Icon, Table, Tooltip, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import * as UserSearchActions from 'app/actions/UserSearchActions';
import { useState } from 'react';

const ExternalEmployeesTableComponent = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    //Datos del store de redux
    const {
        listExternalEmployees,
        isLoadingExternalEmployees,

        filterExternal,
        paginationExternal
    } = useSelector(state => state.UserSearchReducer);

    //destructiracion de la paginación
    const { current, pageSize, total } = paginationExternal;

    //Crear datasource de la tabla con la propiedad 'key'
    const dataSource = listExternalEmployees.map((record) => {
        return {
            'key': record.employeeId,
            ...record
        }

    });

    //Datos para usar en la paginación
    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    //Funcion que maneja los cambios en la tabla (Ordenamiento)
    const handleTableChange = (pagination, filters, sorter) => {
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }
        dispatch(UserSearchActions.savePaginationExternal(obj));

        dispatch(UserSearchActions.fetchExternalEmployees({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : '',
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : '',
            listNames: filterExternal.listExternalEmployeesNames.length > 0 ? filterExternal.listExternalEmployeesNames.join(",") : '',
            listEmails: filterExternal.listExternalEmployeesEmail.length > 0 ? filterExternal.listExternalEmployeesEmail.join(",") : ''
        }));
    }

    //Funcion para mostrar kardex
    const showKardex = (record) => {
        if (record.hasCommunications) {
            props.showKardex(true);
            props.setEmployeeId(record.employeeId);
            props.setExternalUsername(record.userName);
            props.setIsExternal(true);
        } else {
            showModalFunc();
        }
    }

    //Mostrar modal si no existen comunicaciones
    const showModalFunc = () => {
        Modal.info({
            title: 'Sin comunicaciones existentes',
            content: (
                <div>
                    <p>El colaborador seleccionado no cuenta con comunicaciones</p>
                </div>
            ),
            onOk() {
                Modal.destroyAll();
            },
        });
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    //Definición de columnas de la tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            ellipsis: true,
            width: 350,
        },
        {
            title: 'Nombre de Usuario',
            dataIndex: 'userName',
            key: 'userName',
            sorter: true,
            ellipsis: true,
            width: 300,
        },
        {
            title: 'Vigencia',
            dataIndex: 'effectiveDate',
            key: 'effectiveDate',
            sorter: true,
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Correo electrónico',
            dataIndex: 'email',
            key: 'email',
            sorter: true,
            ellipsis: true,
            width: 250,
        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'EmployeeId',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    <Tooltip placement="bottom" title={'Mostrar Kardex'}>
                        <IconButton onClick={() => showKardex(record)}>
                            <Icon type="profile" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    return (
        <Table
            loading={isLoadingExternalEmployees}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationTable}
            // scroll={{ y: 700, x: "min-content" }}
            scroll={{ x: 'min-content', y: (height - 460) }}
            onChange={handleTableChange}
            size="small"
        />
    )
}

export default ExternalEmployeesTableComponent;
